import { useSelector } from "react-redux";
import { RootState } from "../../store";
import styles from "./Avater.module.css";

export default function Avater() {
  const { userName, userImage } = useSelector(
    (state: RootState) => state.auth.user
  );

  return (
    <div className={styles.avater}>
      {userImage !== null && userImage !== undefined ? (
        <div>
          <img src={userImage} alt={userName || "user Name"} />
        </div>
      ) : (
        <div className={styles.avater__text}>
          {userName?.charAt(0).toUpperCase() || "U"}
        </div>
      )}
    </div>
  );
}
